import { render, staticRenderFns } from "./HsabImportedClaimRow.vue?vue&type=template&id=a2a21f76&scoped=true"
import script from "./HsabImportedClaimRow.vue?vue&type=script&lang=ts"
export * from "./HsabImportedClaimRow.vue?vue&type=script&lang=ts"
import style0 from "./HsabImportedClaimRow.vue?vue&type=style&index=0&id=a2a21f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a21f76",
  null
  
)

export default component.exports